import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c22cbd52")

_pushScopeId("data-v-c22cbd52")
const _hoisted_1 = { class: "mobile-loby-root" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "info-1" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "icon icon-user" }, null, -1)
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "info-2" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "setting" }
const _hoisted_9 = { class: "tab-row" }
const _hoisted_10 = { class: "tab" }
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  class: "sort-icon",
  viewBox: "0 0 18 14",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M1 3.5h11.5M9.5 1 13 3.5 9.5 6" }),
  /*#__PURE__*/_createVNode("path", { d: "M17 10.5H5.5M8.5 8 5 10.5 8.5 13" })
], -1)
const _hoisted_12 = { class: "sort-label" }
const _hoisted_13 = /*#__PURE__*/_createVNode("path", { d: "M1 1.5 6 6.5 11 1.5" }, null, -1)
const _hoisted_14 = { class: "sort-menu" }
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "list" }
const _hoisted_17 = { class: "footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_app_svg = _resolveComponent("app-svg")
  const _component_list_item = _resolveComponent("list-item")
  const _component_marquee_text = _resolveComponent("marquee-text")
  const _component_mobile_setting_dialog_view = _resolveComponent("mobile-setting-dialog-view")
  const _component_change_password_view = _resolveComponent("change-password-view")
  const _component_bet_history = _resolveComponent("bet-history")
  const _component_change_pass_required = _resolveComponent("change-pass-required")
  const _component_red_envelop = _resolveComponent("red-envelop")
  const _component_red_envelop_2 = _resolveComponent("red-envelop-2")
  const _component_rule_view = _resolveComponent("rule-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.userId), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_app_svg, {
          box: '0 0 18.067 18.066',
          id: 'coin',
          className: 'coin-svg',
          fill: 'rgb(221, 194, 140)',
          stroke: 'rgb(221, 194, 140)'
        }, null, 8, ["box", "fill", "stroke"]),
        _createVNode("span", _hoisted_7, _toDisplayString(_ctx.betCoin), 1)
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("span", {
          class: "icon icon-setting",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSettings = true))
        })
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("ul", _hoisted_10, [
        _createVNode("li", {
          class: { active: _ctx.selectedTab === 'G005' },
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSelectTab('G005')))
        }, _toDisplayString(_ctx.iN('common.allgames')), 3),
        _createVNode("li", {
          class: { active: _ctx.selectedTab === 'G002' },
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSelectTab('G002')))
        }, _toDisplayString(_ctx.iN('common.baccarat')), 3),
        _createVNode("li", {
          class: { active: _ctx.selectedTab === 'G003' },
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSelectTab('G003')))
        }, _toDisplayString(_ctx.iN('common.dragontiger')), 3)
      ]),
      _createVNode("div", {
        class: "sort-filter",
        onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode("button", {
          type: "button",
          class: "sort-trigger",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleSortMenu && _ctx.toggleSortMenu(...args)))
        }, [
          _hoisted_11,
          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.sortLabel), 1),
          (_openBlock(), _createBlock("svg", {
            class: ["chevron", { open: _ctx.showSortMenu }],
            viewBox: "0 0 12 8",
            "aria-hidden": "true"
          }, [
            _hoisted_13
          ], 2))
        ]),
        _withDirectives(_createVNode("ul", _hoisted_14, [
          _createVNode("li", {
            class: { active: _ctx.sortMode === 'goodRoad' },
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setSortMode('goodRoad')))
          }, _toDisplayString(_ctx.iN('common.goodroadsort')), 3),
          _createVNode("li", {
            class: { active: _ctx.sortMode === 'table' },
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setSortMode('table')))
          }, _toDisplayString(_ctx.iN('common.tablesort')), 3)
        ], 512), [
          [_vShow, _ctx.showSortMenu]
        ])
      ])
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("div", _hoisted_16, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.displayTables, (i) => {
          return (_openBlock(), _createBlock(_component_list_item, {
            class: "item",
            key: i.id,
            deskData: i,
            itemIndex: i.id,
            selectedIndex: _ctx.selectedIndex,
            onClick: ($event: any) => (_ctx.selectItem(i.id)),
            onEnterTable: _ctx.enterTable
          }, null, 8, ["deskData", "itemIndex", "selectedIndex", "onClick", "onEnterTable"]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode(_component_marquee_text, {
        class: "m-notice",
        key: _ctx.infoKey,
        animate: !_ctx.noticeIsPaused,
        speed: 30
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.notice), 1)
        ]),
        _: 1
      }, 8, ["animate"])
    ]),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showSettings)
          ? (_openBlock(), _createBlock(_component_mobile_setting_dialog_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showSettings = false)),
              onOnShowChangePasswordForm: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showPasswordForm = true)),
              onOnShowHistory: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showHistory = true)),
              onOnShowRule: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showRule = true))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showPasswordForm)
          ? (_openBlock(), _createBlock(_component_change_password_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showPasswordForm = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showHistory)
          ? (_openBlock(), _createBlock(_component_bet_history, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showHistory = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showPasswordRequired)
          ? (_openBlock(), _createBlock(_component_change_pass_required, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showPasswordRequired = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade-out" }, {
      default: _withId(() => [
        (_ctx.showPacket)
          ? (_openBlock(), _createBlock(_component_red_envelop, {
              key: 0,
              class: "full-dialog",
              onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showPacket = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade-out" }, {
      default: _withId(() => [
        (_ctx.showPacket2)
          ? (_openBlock(), _createBlock(_component_red_envelop_2, {
              key: 0,
              class: "full-dialog",
              redpackets: _ctx.packet2s,
              onClose: _ctx.onPacket2Close
            }, null, 8, ["redpackets", "onClose"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade-out" }, {
      default: _withId(() => [
        (_ctx.showRule)
          ? (_openBlock(), _createBlock(_component_rule_view, {
              key: 0,
              class: "full-dialog",
              onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showRule = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})